/*
* @Author: Abhi Bhatt
* @Date:   2020-06-24 12:35:52
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-04-08 14:31:20
*/
import React from 'react';
import StaticPagesService from './../../services/StaticPagesService/StaticPagesService';
import USMap from '../../components/Map/USMap';
import GearSpinner from '../../components/GearSpinner/GearSpinner';


const renderHTML = (rawHTML: string) =>
  React.createElement("div", {
    className: "row",
    dangerouslySetInnerHTML: { __html: rawHTML },
  });

class Contact extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			contact_data:{
				contact_tab : [],
				warehouse_tab: []
			},
			is_loader: true,
		}
		this.staticPagesService = new StaticPagesService();
	}

	componentDidMount() {
		if (
      localStorage.getItem('techtop_user_id') != '' &&
      localStorage.getItem('techtop_user_id') != null
    ) {
			this.setState({company: localStorage.getItem('techtop_user_company')});
    }
    this.getContactTabData();
    this.getWarehouseTabData();
	}

	getContactTabData() {
		const permalink = 'new-contact';
		this.staticPagesService.getStaticPage(permalink).then(request=>{
			if(request.status===200) {
				this.setState({is_loader : false});
				this.setState(prevState => ({
				  contact_data: {
				    ...prevState.contact_data,
				    contact_tab: request.data.result.static_page[0].fields
				  }
				}));
			}
		});
	}

	getWarehouseTabData() {
		const permalink = 'warehouse-locations';
		this.staticPagesService.getStaticPage(permalink).then(request=>{
			if(request.status===200) {
				this.setState(prevState => ({
				  contact_data: {
				    ...prevState.contact_data,
				    warehouse_tab: request.data.result.static_page[0].fields
				  }
				}));
			}
		});
	}

	renderContactTab() {
		const { contact_data } = this.state
		let { is_loader } = this.state
		return(
			<React.Fragment>
				<div className="tab-pane active pt-4" id="contact-us">
					{(is_loader) ? (<GearSpinner/>) : renderHTML(contact_data.contact_tab.content)}
				</div>
			</React.Fragment>
		)
	}

	renderWarehouseTab() {
		const { contact_data } = this.state;
		return(
			<React.Fragment>
				<div className="tab-pane mt-3" id="techtop-warehouse-locations">
					<div className="row">
						<div className="col-md-12">
							<USMap />
							<div className="company-address">
								{renderHTML(contact_data.warehouse_tab.content)}
								<div className="row pt-3">
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Dallas">
										<div className="company-address-div">
											<h5>Dallas, Tx</h5>
											<p className="m-0">ROBCO</p>
											<p className="m-0">1523 Crescent Drive Carrollton, TX 75006</p>
											<p className="m-0">Phone: <a href="tel:8004447609">800-444-7609</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Phoenix">
										<div className="company-address-div">
											<h5>PHOENIX,AZ</h5>
											<p className="m-0">Phoenix Warehouse Company 4022</p>
											<p className="m-0">West Turney Suite A-1 Phoenix, AZ 85019</p>
											<p className="m-0">Phone: <a href="tel:6022782886">602-278-2886</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Reno">
										<div className="company-address-div">
											<h5>RENO, NV</h5>
											<p className="m-0">Landstar/Advanced Logistics 1285B</p> 
											<p className="m-0">Southern Way Sparks, NV 89431</p>
											<p className="m-0">Phone: <a href="tel:7754320336">775-432-0336</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Houston">
										<div className="company-address-div">
											<h5>HOUSTON, TX</h5>
											<p className="m-0">BEECO</p>
											<p className="m-0">5630 Guhn Road # 100 Houston, TX 77040</p>
											<p className="m-0">Phone: <a href="tel:8004447609">800-444-7609</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Fresno">
										<div className="company-address-div">
											<h5>FRESNO, CA</h5>
											<p className="m-0">Engineered Industrial Products, Inc</p> 
											<p className="m-0">1816 S Van Ness Ave. Fresno, CA 93721</p>
											<p className="m-0">Phone: <a href="tel:5593657949">559-365-7949</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4">
										<div className="company-address-div">
											<h5>CLEVELAND, OH</h5>
											<p className="m-0">IMC</p>
											<p className="m-0">4540 Glennbrook Dr. Willoughby, OH 44094</p>
											<p className="m-0">Phone: <a href="tel:4409515703">440-951-5703 x8</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Odessa">
										<div className="company-address-div">
											<h5>ODESSA, TX</h5>
											<p className="m-0">Diversified Warehouse, Inc</p> 
											<p className="m-0">635 Industrial Ave Odessa, TX 79761</p>
											<p className="m-0">Phone: <a href="tel:4323320416">432-332-0416</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Portland">
										<div className="company-address-div">
											<h5>PORTLAND, OR</h5>
											<p className="m-0">Northwest Warehouse</p> 
											<p className="m-0">7615 N. Upland Dr. Portland, OR 97203</p>
											<p className="m-0">Phone: <a href="tel:5037354082">503-735-4082</a></p>
										</div>
									</div>
									<div className="col-md-6 col-sm-6 col-lg-4 col-xl-4 map_location Itasca">
										<div className="company-address-div">
											<h5>ITASCA, IL</h5>
											<p className="m-0">4C Logistics</p> 
											<p className="m-0">921 Ardmore Ave Itasca, IL 60143</p>
											<p className="m-0">Phone: <a href="tel:6307759103">630-775-9103</a></p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}

	render() {
		let contact_data = this.state.contact_data;
		const { company } = this.state;
		return(
			<React.Fragment>
				<main className="techtop-middle-div">
					<section className="techtop-contact-section py-5">	
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<ul className="nav nav-tabs card-header-tabs" data-bs-tabs="tabs">
										<li className="nav-item">
											<a className="nav-link active" aria-current="true" data-bs-toggle="tab" href="#contact-us">Contact us</a>
										</li>
										<li className="nav-item">
											<a className="nav-link" data-bs-toggle="tab" href="#techtop-warehouse-locations">Techtop Warehouse Locations</a>
										</li>
									</ul>
								</div>
								<div className="col-md-12">
									<div className="tab-content contact-section">
										{this.renderContactTab()}
										{this.renderWarehouseTab()}
									</div>
								</div>	
							</div>	
							
						</div>
					</section>
				</main>
			</React.Fragment>
		)
	}
}

export default Contact;